import { toast, Bounce } from 'react-toastify';

/**
 * Tell the user an on-chain write never landed.
 *
 * `transactionAction()` resolves to null when the transaction was never mined —
 * the wallet rejected it, the relayer errored, or the chain refused it. Callers
 * that ignore that result leave the UI silently reverting to its previous state,
 * which reads as "nothing happened". Pass the action in user terms, e.g.
 * notifyChainFailure('star this email').
 */
export function notifyChainFailure(action) {
  toast.error(`Couldn't ${action} — the blockchain transaction failed. Please try again.`, {
    position: 'top-center',
    transition: Bounce,
  });
}
